<template>
  <div>
    <div class="page-header-wrapper padding-rb">
      <PageHeader title="User List">
        <el-input prefix-icon="el-icon-search" placeholder="Search" v-model="searchVal" v-debounce="onSearch" clearable
          @clear="onSearch" />
        <el-button type="primary" icon="el-icon-plus" @click="handleNewUser" v-if='!isSupervisor'>
          New User
        </el-button>
      </PageHeader>
    </div>
    <div class="table-wrapper">
      <el-table size="mini" v-loading="tableLoading" element-loading-text="Loading..." :data="tableData"
        @sort-change="onSortChange" ref="SeTable">
        <el-table-column prop="No" label="No." sortable="custom" width="80" />
        <el-table-column prop="Name" label="Name" sortable="custom" min-width="100" />
        <el-table-column prop="LoginName" label="Login Name" sortable="custom" min-width="140" />
        <el-table-column prop="Description" label="Role" sortable="custom" min-width="90" />
        <el-table-column prop="TeamName" label="Team" sortable="custom" min-width="110" />
        <el-table-column prop="Manager" label="Manager" sortable="custom" min-width="120"
          :formatter="managerFormatter" />
        <el-table-column prop="TaConfigName" label="TA" sortable="custom" min-width="110" />
        <el-table-column prop="Phone" label="Phone" sortable="custom" min-width="100" />
        <el-table-column prop="Email" label="Email" sortable="custom" min-width="120" />
        <el-table-column label="Operation" width="110" align="center">
          <template slot-scope="{ row }" prop="StatusDesc">
            <OptionMenu icon="iconfont icon-more-menu" iconSize="18">
              <OptionMenuItem icon="el-icon-edit" title="Edit" @click="handleEditUser(row)" />
              <OptionMenuItem icon="el-icon-delete" title="Delete" @click="handleDelete(row)" />
              <OptionMenuItem icon="el-icon-document" title="Operation History" @click="handleOperationLog(row)" />
            </OptionMenu>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 25, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" />
      </div>
    </div>
    <NewUserDialog :visible.sync="newUserDialogVisible" @success="onSuccess(true)" />
    <EditUserDialog :visible.sync="editUserDialogVisible" :data.sync="editRow" @success="onSuccess" />
    <UserOperationLogDialog :visible.sync="operationLogDialogVisible" :data.sync="operationLogRow" />
  </div>
</template>
<script>
import NewUserDialog from "./new-user-dialog";
import EditUserDialog from "./edit-user-dialog";
import UserOperationLogDialog from "./user-operation-log-dialog";
import { RoleCode } from '@/utils/role-constant'

export default {
  name: "Lilly-User",
  components: { NewUserDialog, EditUserDialog, UserOperationLogDialog },
  data() {
    return {
      dateFormat: "YYYY-MM-DD HH:mm:ss",
      searchVal: "",
      tableLoading: true,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      orderBy: "CreatedOn",
      orderType: "descending",
      newUserDialogVisible: false,
      editUserDialogVisible: false,
      editRow: null,
      operationLogDialogVisible: false,
      operationLogRow: null,
    };
  },
  computed: {
    isSupervisor() {
      return this.$store.state.role === RoleCode.Supervisor
    },
  },
  created() {
    this.getTableData();
    this.bus.$on("refresh", ({ name }) => {
      if (this.$options.name === name) {
        this.getTableData();
      }
    });
  },
  methods: {
    managerFormatter(row) {
      const { RoleName, TAName, Manager } = row;
      return RoleName === "CRP" || RoleName === "SciCom" || RoleName === "CVEO" || RoleName === "ClinTrans" ? TAName : Manager
    },
    onSearch() {
      this.currentPage = 1;
      this.getTableData();
    },
    getTableData() {
      this.tableLoading = true;
      this.axios
        .get(`/user/userlist`, {
          params: {
            pageSize: this.pageSize,
            page: this.currentPage,
            orderBy: this.orderBy,
            orderType: this.orderType,
            key: this.searchVal,
          },
        })
        .then(({ code, data, msg }) => {
          this.tableLoading = false;
          if (200 === code) {
            this.tableData = data.data;
            this.total = data.total;
          } else {
            this.$message.error(msg);
          }
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    onSuccess(resetPage = false) {
      this.orderBy = resetPage ? "CreatedOn" : this.orderBy;
      this.currentPage = resetPage ? 1 : this.currentPage;
      this.getTableData();
    },
    onSortChange(column) {
      this.orderBy = column.prop;
      this.orderType = column.order;
      this.getTableData();
    },
    handleNewUser() {
      this.newUserDialogVisible = true;
    },
    handleEditUser(row) {
      this.editRow = row;
      this.editUserDialogVisible = true;
    },
    handleDelete(row) {
      this.$confirm("Once deleted, it cannot be recovered.", "Attention", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
      }).then(() => {
        this.axios
          .get(`/user/delete?userID=${row.UserID}`)
          .then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "Delete user successfully",
              });
              this.getTableData();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "info",
              message: "error: " + err,
            });
          });
      });
    },
    handleOperationLog(row) {
      this.operationLogRow = row;
      this.operationLogDialogVisible = true;
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getTableData();
    },
  },
};
</script>